import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useUserRole } from '@/hooks/useUserRole';
import { Loader2 } from 'lucide-react';

type MinRole = 'operator' | 'supervisor' | 'org_admin' | 'superadmin';

const ROLE_LEVEL: Record<string, number> = {
  operator: 0,
  supervisor: 1,
  org_admin: 2,
  superadmin: 3,
};

interface Props {
  children: React.ReactNode;
  minRole?: MinRole;
}

export default function ProtectedRoute({ children, minRole }: Props) {
  const { user, loading: authLoading } = useAuth();
  const { role, loading: roleLoading } = useUserRole();

  if (authLoading || roleLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) return <Navigate to="/auth" replace />;

  if (minRole) {
    const userLevel = ROLE_LEVEL[role ?? 'operator'] ?? 0;
    const requiredLevel = ROLE_LEVEL[minRole] ?? 0;
    if (userLevel < requiredLevel) {
      return <Navigate to="/inbox" replace />;
    }
  }

  return <>{children}</>;
}
